module.exports = __webpack_public_path__ + "static/3-9130f562d5db9aef57fe90a3dd3e5728.jpeg";